const Menu = (): React.JSX.Element => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 13 7">
        <path stroke="#010130" strokeWidth="2" d="M0 1h12.5M0 6h12.5" />
    </svg>
}
export default Menu;


